export type TaskPriority = "low" | "medium" | "high" | "urgent";

export const TASK_PRIORITY_OPTIONS: { value: TaskPriority; label: string }[] = [
  { value: "low", label: "Baixa" },
  { value: "medium", label: "Média" },
  { value: "high", label: "Alta" },
  { value: "urgent", label: "Urgente" },
];

export interface TaskPriorityMeta {
  label: string;
  className: string;
}

export function matchesTaskPriorityFilter(
  priority: TaskPriority | null | undefined,
  selected: TaskPriority[],
): boolean {
  if (selected.length === 0) return true;
  return selected.includes(priority ?? "medium");
}

export function filterTasksByPriority<T extends { priority?: TaskPriority | null }>(
  tasks: T[],
  selected: TaskPriority[],
): T[] {
  if (selected.length === 0) return tasks;
  return tasks.filter((task) => matchesTaskPriorityFilter(task.priority, selected));
}

export function getTaskPriorityMeta(priority: TaskPriority = "medium"): TaskPriorityMeta {
  switch (priority) {
    case "low":
      return {
        label: "Baixa",
        className: "bg-muted text-muted-foreground border-transparent hover:bg-muted",
      };
    case "high":
      return {
        label: "Alta",
        className:
          "bg-amber-500/15 text-amber-800 border-amber-500/40 dark:text-amber-300 hover:bg-amber-500/15",
      };
    case "urgent":
      return {
        label: "Urgente",
        className:
          "bg-destructive/15 text-destructive border-destructive/40 hover:bg-destructive/15",
      };
    case "medium":
    default:
      return {
        label: "Média",
        className:
          "bg-slate-500/10 text-slate-700 border-slate-500/30 dark:text-slate-300 hover:bg-slate-500/10",
      };
  }
}
